<div>
  <div class="col-md-12 col-lg-12">
    <div class="col-sm-4">
      <h4><b>{{ "pages.createReceiptPage.consigneeDetails.consigneeDetails" | translate }}</b></h4>
    </div>
    <div [@openClose]="!isOpen ? 'open' : 'closed'">
      <div class="col-sm-2">
        <h4>&nbsp;</h4>
      </div>
      <div class="col-sm-3">
        <h4 class="change {{enableChange? '':'disabled'}}" (click)="change()">{{ 'common.change' | translate }}</h4>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 col-lg-12 mrgin-lft mob-mrgin">
        <div class="details-container" [@openClose]="!isOpen ? 'open' : 'closed'">
          <div class="row">
            <div class="col-sm-3">{{ 'common.mobile' | translate }}</div>
            <div class="col-sm-3" title="{{consigneeDetails.mobile}}">{{consigneeDetails.mobile}}</div>
            <div class="col-sm-3">{{ 'common.telephone' | translate }}</div>
            <div class="col-sm-3" title="{{consigneeDetails.telephone}}">{{consigneeDetails.telephone}}</div>
          </div>
          <div class="row">
            <div class="col-sm-3">{{ 'common.name' | translate }}</div>
            <div class="col-sm-3 text-elp" title="{{consigneeDetails.name}}">{{consigneeDetails.name}}</div>
            <div class="col-sm-3">{{ "pages.createReceiptPage.consigneeDetails.attention" | translate }}</div>
            <div class="col-sm-3 text-elp" title="{{consigneeDetails.attention}}">{{consigneeDetails.attention}}</div>
          </div>
          <div class="row">
            <div class="col-sm-3">{{ "common.addressLine" | translate }}</div>
            <div class="col-sm-3 text-elp" title="{{consigneeDetails.addressLine}}">{{consigneeDetails.addressLine}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="form-container" [@openClose]="isOpen ? 'open' : 'closed'">
  <div class="row">
    <div class="col-md-4 col-sm-10">
      <div class="form-group">
        <label class="control-label">{{ 'common.mobile' | translate }}</label>
        <input class="form-control" [(ngModel)]="consigneeDetails.mobile" autocomplete="disabled"
          (blur)="resolvePhone($event.target.value)" />
        <span [innerHtml]="validatorObject.mobile.message"></span>
      </div>
    </div>
    <div class="col-md-4 col-sm-10">
      <div class="form-group">
        <label class="control-label">{{ 'common.telephone' | translate }}</label>
        <input class="form-control" autocomplete="disabled" [(ngModel)]="consigneeDetails.telephone" />
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-4 col-sm-10">
      <div class="form-group">
        <label class="control-label">{{ 'common.name' | translate }}</label>
        <input class="form-control" autocomplete="disabled" [(ngModel)]="consigneeDetails.name"
          (blur)="checkRequiredField('name')" />
        <span [innerHtml]="validatorObject.name.message"></span>
      </div>
    </div>
    <div class="col-md-4 col-sm-10">
      <div class="form-group">
        <label class="control-label">{{ "pages.createReceiptPage.consigneeDetails.attention" | translate }}</label>
        <input class="form-control" [(ngModel)]="consigneeDetails.attention" autocomplete="disabled"
          (blur)="checkRequiredField('attention')" />
        <span [innerHtml]="validatorObject.attention.message"></span>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-4 col-sm-10" *ngIf="productType.toLowerCase() != 'cac'">
      <div class="form-group">
        <label class="control-label">{{ "common.addressLine" | translate }}</label>
        <input #AddressLine class="form-control" [(ngModel)]="consigneeDetails.addressLine" autocomplete="disabled"
          (blur)="checkRequiredField('addressLine')" />
        <span [innerHtml]="validatorObject.addressLine.message"></span>
      </div>
    </div>
    <div class="col-md-4 col-sm-10" *ngIf="productType.toLowerCase() == 'cac'">
      <div class="form-group">
        <!--<label class="control-label">Pickup Branches</label>
         <select class="form-control" [ngModel]="selectedBranchId" (ngModelChange)="selectedBranchId = $event;required=''">
          <option value="-1">Select pick up branch</option>
          <option *ngFor="let i of pickUpBranches" value="{{i.BranchId}}">{{i.Name}}</option>
        </select>  -->
        <label class="control-label">Pickup Branches</label>
        <mat-select class="form-control" placeholder="Select pick up branch" [ngModel]="selectedBranch"
          (ngModelChange)="onBranchChange($event)">
          <mat-select-trigger>{{ selectedBranch.Name}}</mat-select-trigger>
          <mat-option>
            <lib-mat-select-search [list]="pickUpBranches" [searchProperties]="['Name']"
              (filtered)="FilteredpickUpBranches = $event" (blur)="checkRequiredField('addressLine')">
            </lib-mat-select-search>
          </mat-option>
          <mat-option *ngFor="let i of FilteredpickUpBranches" [value]="i">
            <div>
              <span>{{ i.Name }}</span>
            </div>
          </mat-option>
        </mat-select>
        <span [innerHtml]="required"></span>
      </div>
    </div>
    <div class="col-md-4 col-sm-10">
      <div class="form-group">
        <label class="control-label">{{ 'common.email' | translate }}</label>
        <input class="form-control" [(ngModel)]="consigneeDetails.email" (blur)="checkRequiredField('email')"
          autocomplete="disabled" />
        <span [innerHtml]="validatorObject.email.message"></span>
      </div>
    </div>

  </div>
  <div class="row">
    <div class="col-md-4 col-sm-10">
      <div class="form-group">
        <label class="control-label">{{ 'common.consigneeReference' | translate}}</label>
        <input class="form-control" [(ngModel)]="consigneeDetails.consigneeReferance" autocomplete="disabled" />
      </div>
    </div>
    <div class="col-md-4 col-sm-10">
      <div class="form-group">
        <label class="control-label">{{ 'common.consigneeReference2' | translate}}</label>
        <input class="form-control" [(ngModel)]="consigneeDetails.consigneeReferance2" autocomplete="disabled" />
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-4 col-sm-10">
      <div class="form-group">
        <label class="control-label">Short Code</label>
        <input class="form-control" autocomplete="disabled" (blur)="checkRequiredField('shortCode')"
          [(ngModel)]="consigneeDetails.shortCode" [disabled]="!shortCodeGrayed" />
        <span [innerHtml]="validatorObject.shortCode.message"></span>
      </div>
    </div>
  </div>

  
  <div class="row">
    <div class="col-md-8 col-sm-10">
      <div class="form-group">
        <button class="btn btn-info" (click)="resolveShortCodeBTN()">Resolve Short Code</button>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-md-8 col-sm-10">
      <div class="form-group">
        <button class="btn btn-primary" (click)="fillConsigneeDetails()">{{ 'common.next' | translate }}</button>
      </div>
    </div>
  </div>
</div>